<div *ngIf="gameResultsDisplay, else message" class="game-results">

    <app-display-ball class="ball-game-results" [ball]="winnerBall"></app-display-ball>
    <div *ngIf="isWinner, else lost">
        <p>Awesome, you won {{moneyWon}} euros!</p>
    </div>
    <ng-template #lost>
        <p>Oh no, you lose!</p>
    </ng-template>

    <div>
        <button class="btn btn-primary" type="text" (click)="clearGame()">Play Again?</button>
    </div>

</div>
<ng-template #message>
    <div class="message">
        <p>Good Luck!</p>
    </div>
</ng-template>